import { render, staticRenderFns } from "./giftTempModal.vue?vue&type=template&id=0f47bdcc&scoped=true"
import script from "./giftTempModal.vue?vue&type=script&lang=ts"
export * from "./giftTempModal.vue?vue&type=script&lang=ts"
import style0 from "./giftTempModal.vue?vue&type=style&index=0&id=0f47bdcc&prod&lang=css"
import style1 from "./giftTempModal.vue?vue&type=style&index=1&id=0f47bdcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47bdcc",
  null
  
)

export default component.exports